import produce from 'immer'
import { useReducer, useMemo } from 'react'

const initialState = {
  signInStatus: '',
  userToken: null,
}

const reducer = (prevState, action) => {
  switch (action.type) {
    case 'RESTORE_TOKEN':
      return produce(prevState, draftState => {
        draftState.userToken = action.token
      })
    case 'SIGN_IN':
      return produce(prevState, draftState => {
        draftState.signInStatus = action.signInStatus
      })
  }
}

const useAuthReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const actions = useMemo(
    () => ({
      signIn: signInStatus =>
        dispatch({
          type: 'SIGN_IN',
          signInStatus,
        }),
      restoreToken: token =>
        dispatch({
          type: 'RESTORE_TOKEN',
          token,
        }),
    }),
    [],
  )

  return {
    state,
    ...actions,
  }
}
export default useAuthReducer
